import RetributionsService from "@/api/services/retributions";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  retributionsAnalytics: {},
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setRetributionsAnalytics(state, retributionsAnalytics) {
      state.retributionsAnalytics = retributionsAnalytics;
    },
  },
  actions: {
    async fetchRetributionsAnalytics({ commit }, { storeId, startAt, endAt } = {}) {
      const response = await RetributionsService.fetchAnalytics({ storeId, startAt, endAt });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setRetributionsAnalytics", data);
      return data;
    },

    async fetchIndex(_, { startAt, endAt, sellerId, includes } = {}) {
      return await RetributionsService.fetchIndex({ startAt, endAt, sellerId, includes });
    },

    async exportRetributions(_, { storeIds, startAt, endAt } = {}) {
      return await RetributionsService.export({ storeIds, startAt, endAt });
    },
  },
};
